export default "__VITE_ASSET__ov3QhjXW__"